import React from 'react'
import WidgetBody from './WidgetBody'
import LoadingSpinner from '../LoadingSpinner'
import ApiError from './ApiError'
import { LoadingState } from './types'
import { useWidget } from './WidgetContext'

const WidgetLoader: React.FC = () => {
  const { errorMsg, loadingState } = useWidget()

  switch (loadingState) {
    case LoadingState.LOADED:
      return <WidgetBody />

    case LoadingState.ERROR:
      return <ApiError errorMsg={errorMsg} shouldRender />

    case LoadingState.LOADING:
      return <LoadingSpinner />

    default:
      return <></>
  }
}

export default WidgetLoader
